module.exports = __webpack_public_path__ + "img/pc.551f2907.png";